export function map<A, B>(fn: (value: A) => B, value: A | null): B | null {
    if (value !== null) {
        return fn(value)
    } else {
        return value
    }
}

export function andThen<A, B>(fn: (value: A) => B | null, value: A | null): B | null {
    if (value !== null) {
        return fn(value)
    } else {
        return value
    }
}

export function withDefault<T>(defaultValue: T, value: T | null): T {
    return value !== null ? value : defaultValue
}

export function fromPossiblyUndefined<T>(value: T | undefined): T | null {
    return typeof value !== 'undefined' ? value : null
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Nullable.ts